const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_LIBRARY_CATEGORIES_LIST",
  FETCH_LIST_REQUEST: "FETCH_LIBRARY_CATEGORIES_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_LIBRARY_CATEGORIES_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_LIBRARY_CATEGORIES_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_LIBRARY_CATEGORIES_LIST",
}

export default LIST_ACTION_TYPES
